import React from 'react';
import { MidFooter as ChaosFooter } from '@chaos/layout';
import '@chaos/layout/dist/index.css';

const Footer = () => {
  return <ChaosFooter url={`${window.WEBSITE_URL}/api/footer`} />;
};

export default Footer;
